<script>
import ProductIndicator from "./ProductIndicator.vue";
import VideoPlayer from "./AppVideoPlayerwithObserver.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    ProductIndicator,
    VideoPlayer,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      observer: null,
    };
  },
  computed: {
    ...mapGetters(["watchVideo"]),
  },

  methods: {
    ...mapActions(["toggleModal"]),
  },
};
</script>

<template>
  <article class="fullScreen vw-dark-surface vw-component">
    <VideoPlayer :video="content.video" />

    <div class="overlay">
      <section class="vw-grid">
        <div class="content">
          <h2 class="title heading-3 vw-component-title">
            {{ content.title }}
          </h2>
          <p class="copy body-copy-1 vw-component-content">
            {{ content.copy }}
            <a
              v-if="typeof content.video !== 'undefined'"
              @click.prevent="toggleModal(content.video)"
              href="#"
              class="learnMore"
              >{{ watchVideo }}</a
            >
          </p>
          <ProductIndicator
            class="indicator vw-component-indicator"
            :active-products="content.products"
          />
        </div>
      </section>
    </div>
  </article>
</template>

<style lang="scss" scoped>
@import "../styles/01-settings/breakpoints";
@import "../styles/01-settings/mq";

.fullScreen {
  height: 100vh;
  min-height: 800px;
  //   background: hsla(241, 24%, 39%, 1);
  position: relative;
}
video {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 1;
  background-color: hsla(0, 0%, 0%, 0.6);
  z-index: 10;
}
.gradient {
  background-color: transparent;
  background-image: radial-gradient(
    circle at 32% 28%,
    #000000 0%,
    rgba(0, 0, 0, 0.99) 2%,
    rgba(0, 0, 0, 1) 33%,
    rgba(0, 0, 0, 0) 90%
  );
}

section {
  color: var(--text-color);
  height: 100%;
}
.vw-grid {
  margin-top: 100px;
}
.content {
  grid-column: 1 / -1;
}
.vw-component-indicator {
  margin-left: 0;
}
p,
h2 {
  color: var(--text-color);
  text-shadow: 0px 0px 15px #0000003a;
}
.title,
.copy {
  grid-column: 1/-1;
  text-align: left;
}
.copy {
  // margin-top: 20px;
}
.title {
  // margin-top: 12vw;
}
.indicator {
  grid-column: 1/-1;
  // margin-top: 44px;
}

@include mq($from: sm, $until: md) {
  .content {
    grid-column: 1 / span 4;
  }
}
@include mq($from: md) {
  .vw-grid {
    margin-top: 180px;
    padding: 0 var(--layout-margin);
  }
  section {
    padding: 0;
  }

  .content {
    grid-column: 1 / span 6;
  }
  .vw-component-indicator {
    margin-left: 0;
  }
  p,
  h2 {
    text-shadow: 0px 0px 15px #0000003a;
  }
}
@include mq($until: lg) {
  .learnMore {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/FullBleedVideo.vue